import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {BubbleNoti}     from "@Common/ui-components/bubble-noti/bubble-noti";

// TODO Needs to move to common since it is referenced by
//  /ui/common/ui-components/heavy/mailing-ui/ml-list-table/ml-content-data-columns.tsx
export const DownloadMailingList = ({next, mailingList}) => cs(
    consumeContext("apis"),
    ["bubbleNoti", (_, next) => BubbleNoti({next})],
    ({apis, bubbleNoti}) => next(async () => {
        const data = await apis.next.mailing.downloadMailingList(mailingList);
        if(data.status === 401) {
            bubbleNoti.show({
                message: "Session has Expired",
                color: "red",
            })
        }
        if(data.status !== 200) {
            bubbleNoti.show({
                message: "Unauthorized",
                color: "red",
            })
        }
        else {
            const blob = new Blob([await data.text()], {type: 'text/csv'});
            const filename = mailingList.mailingListName.replace(/[/\\?%*:|"<>]/g, '-') + ".csv";
            var link = document.createElement("a");
            link.setAttribute("href", window.URL.createObjectURL(blob));
            link.setAttribute("download", `${filename}`);
            document.body.appendChild(link);
            link.click(); 
        }
    })
)